import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useClient } from '../../client-api';
import { createLifeEvent, type LifeEventCreateDto, type LifeEventDto } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export const useCreateLifeEvent = (): UseMutationResult<LifeEventDto, AxiosError, LifeEventCreateDto> => {
    const queryClient = useQueryClient();
    const { data: client } = useClient();

    return useMutation({
        mutationFn: (event) => createLifeEvent({ body: event }).then((result) => result.data!),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.events(client?.partnerUuid) });
            queryClient.invalidateQueries({ queryKey: queryKeys.notifications() });
            queryClient.invalidateQueries({ queryKey: queryKeys.notificationsForClient(client?.id) });
        },
    });
};
